import {Injectable} from "@angular/core";
import {ListRemote} from "@app/core/lists/domain/list.remote";
import {Observable} from "rxjs";
import {List} from "@app/core/lists/domain/list";
import {TrackAddToWishlistUseCase} from "@app/core/tracking/application/track-add-to-wishlist.use-case";
import {Product} from "@app/core/product/domain/dtos/product";

@Injectable({
    providedIn: 'root'
})
export class AddProductToListUseCase {
    constructor(
        private listRemote:ListRemote,
        private trackAddToWishlistUseCase: TrackAddToWishlistUseCase,
    ) { }

    /**
     * Add a product to a list.
     * @param listId - The id of the list to add the product to.
     * @param product - The product to add to the list.
     * @param quantity - The quantity of the product to add to the list.
     *                   Since the quantity will always be 1, this parameter could be removed in future versions.
     * @returns An observable that emits the list after the product has been added to it.
     */
    execute(listId:number, product:Product, quantity:number): Observable<List> {
        this.trackAddToWishlistUseCase.execute({
            value: product.price ?? 0,
            items: [{
                itemId: product.code,
                itemName: product.name,
            }]
        });
        return this.listRemote.addProductToList(listId, product.code, quantity);
    }
}
